import { gql } from '@apollo/client'
import { queryGQL } from '../../gqlActions'
import {
  deleteRefreshTokenFromCookies,
  getRefreshTokenFromCookies,
  saveRefreshTokenToCookies
} from 'src/utils/authentication'
import { InvalidCredentialsError, UserNotActiveError } from 'src/utils/errors/authentication'

const LOGIN_CREDENTIALS = gql`
  query login($username: String!, $password: String!) {
    loginWithCreds(username: $username, password: $password) {
      RefreshToken
      AccessToken
      email
      userId
      firstName
      lastName
    }
  }
`

export const LOGIN_TOKEN = gql`
  query login($refreshToken: String!) {
    loginWithToken(refreshToken: $refreshToken) {
      username
    }
  }
`

const REVOKE_TOKEN = gql`
  query revokeToken($refreshToken: String!) {
    revokeToken(refreshToken: $refreshToken)
  }
`

const GET_USER_LICENSES = gql`
  query UserLicenseCount($applicationId: String!, $accessToken: String!) {
    userLicenseCount(applicationID: $applicationId, accessToken: $accessToken) {
      total
    }
  }
`

export const loginWithCredsGQL = async (username: string, password: string) => {
  try {
    const result = await queryGQL({
      query: LOGIN_CREDENTIALS,
      variables: { username, password },
      key: 'loginWithCreds',
      clientType: 'gems'
    })

    saveRefreshTokenToCookies(result.RefreshToken)
    return result
  } catch (error: any) {
    if (error?.message === 'User is not active') {
      throw new UserNotActiveError()
    }
    // TODO: Remove the first condition when this is fixed in gems
    else if (
      error?.message === "Cannot read properties of undefined (reading 'Active')" ||
      error?.message === 'Incorrect username or password.'
    ) {
      throw new InvalidCredentialsError()
    } else {
      throw error
    }
  }
}

export const loginWithTokenGQL = async () => {
  try {
    const refreshToken = getRefreshTokenFromCookies()
    if (!refreshToken) {
      return
    }

    const result = await queryGQL({
      query: LOGIN_TOKEN,
      variables: { refreshToken },
      key: 'loginWithToken',
      clientType: 'gems'
    })
    return result
  } catch (error) {
    // If the user's session can't be restored, delete the refresh token to enforce re-login
    deleteRefreshTokenFromCookies()
  }
}

export const revokeTokenGQL = async (refreshToken: string) => {
  try {
    await queryGQL({
      query: REVOKE_TOKEN,
      variables: { refreshToken },
      key: 'revokeToken',
      clientType: 'gems'
    })
  } catch (error) {
    console.error('Error revoking token:', error)
  }
}

export const getUserLicensesGQL = async (applicationId: string, accessToken: string): Promise<any> => {
  return queryGQL({
    query: GET_USER_LICENSES,
    variables: { applicationId, accessToken },
    key: 'userLicenseCount',
    clientType: 'gems'
  })
}
